import { Injectable } from '@angular/core';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (value) {
      const date = new Date(Date.parse(value));
      return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      };
    }
    return null;
  }
  format(date: NgbDateStruct): string {
    if (date) return `${date.month}/${date.day}/${date.year}`;

    return null;
  }
}

@Injectable()
export class CustomDateAdapter extends NgbDateAdapter<string> {
  fromModel(value: string): NgbDateStruct {
    if (value) {
      const date = new Date(Date.parse(value));
      return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      };
    }
    return null;
  }
  toModel(date: NgbDateStruct): string {
    if (date) {
      const dt = new Date(date.year, date.month - 1, date.day);
      return dt.toISOString();
    }
    return null;
  }
}
